import { IconProps } from './types';
import React, { MouseEvent } from 'react';
import { ReactComponent as ChevronSvg } from '../assets/icons/chevron-left.svg';
import clsx from 'clsx';
import { twMerge } from '@shared/utils/twMerge';

type ChevronIconProps = {
  dir?: 'left' | 'right' | 'up' | 'down';
  classNameButton?: string;
  onClick?: (e: MouseEvent<HTMLElement>) => void;
  dataTestid?: string;
};

const rotation = {
  left: '',
  right: 'rotate-180',
  up: 'rotate-90',
  down: '-rotate-90',
};

export const ChevronIcon = ({
  className,
  classNameButton,
  onClick,
  dir = 'left',
  dataTestid = 'chevronIcon',
}: IconProps & ChevronIconProps) => {
  return (
    <div
      className={twMerge(
        'flex items-center justify-center transition-all',
        rotation[dir],
        classNameButton
      )}
      onClick={onClick}
      data-testid={dataTestid}
    >
      <ChevronSvg className={clsx(className)} />
    </div>
  );
};

export default ChevronIcon;
